!function (t, e) {
  "object" == typeof exports && "object" == typeof module ? module.exports = e() : "function" == typeof define && define.amd ? define([], e) : "object" == typeof exports ? exports["@hotmart/cosmos"] = e() : t["@hotmart/cosmos"] = e();
}(self, function () {
  return (() => {
    "use strict";

    var t = {
        7705: t => {
          t.exports = function (t) {
            var e = [];
            return e.toString = function () {
              return this.map(function (e) {
                var o = "",
                  n = void 0 !== e[5];
                return e[4] && (o += "@supports (".concat(e[4], ") {")), e[2] && (o += "@media ".concat(e[2], " {")), n && (o += "@layer".concat(e[5].length > 0 ? " ".concat(e[5]) : "", " {")), o += t(e), n && (o += "}"), e[2] && (o += "}"), e[4] && (o += "}"), o;
              }).join("");
            }, e.i = function (t, o, n, r, i) {
              "string" == typeof t && (t = [[null, t, void 0]]);
              var a = {};
              if (n) for (var s = 0; s < this.length; s++) {
                var c = this[s][0];
                null != c && (a[c] = !0);
              }
              for (var d = 0; d < t.length; d++) {
                var l = [].concat(t[d]);
                n && a[l[0]] || (void 0 !== i && (void 0 === l[5] || (l[1] = "@layer".concat(l[5].length > 0 ? " ".concat(l[5]) : "", " {").concat(l[1], "}")), l[5] = i), o && (l[2] ? (l[1] = "@media ".concat(l[2], " {").concat(l[1], "}"), l[2] = o) : l[2] = o), r && (l[4] ? (l[1] = "@supports (".concat(l[4], ") {").concat(l[1], "}"), l[4] = r) : l[4] = "".concat(r)), e.push(l));
              }
            }, e;
          };
        },
        6738: t => {
          t.exports = function (t) {
            return t[1];
          };
        },
        1464: (t, e, o) => {
          o.d(e, {
            Z: () => s
          });
          var n = o(6738),
            r = o.n(n),
            i = o(7705),
            a = o.n(i)()(r());
          a.push([t.id, ':host{display:inline-block}:host(.hot-dropdown--active),:host([active]){z-index:2}:host>div{position:relative}.hot-dropup,.hot-dropright,.hot-dropdown,.hot-dropleft{position:relative}.hot-dropdown__menu{background:var(--white, #ffffff);border-color:transparent;-webkit-border-radius:var(--border-radius, 0.25rem);-moz-border-radius:var(--border-radius, 0.25rem);border-radius:var(--border-radius, 0.25rem);border-style:solid;border-width:var(--dropdown-border-width, 0.0625rem);-webkit-box-shadow:var(--box-shadow, 0 8px 16px -6px rgba(0, 0, 0, 0.12));-moz-box-shadow:var(--box-shadow, 0 8px 16px -6px rgba(0, 0, 0, 0.12));box-shadow:var(--box-shadow, 0 8px 16px -6px rgba(0, 0, 0, 0.12));color:var(--gray-700, #32363b);display:none;font-size:var(--text-2, 1rem);list-style:none;margin:0;min-width:var(--dropdown-menu-width, 12rem);opacity:0;overflow:hidden;padding:var(--dropdown-menu-padding, 0.5rem 0);pointer-events:none;position:absolute;top:100%;-webkit-transition:opacity var(--timing, 500ms) var(--easing, 500ms),-webkit-transform var(--timing, 500ms) var(--easing, 500ms);transition:opacity var(--timing, 500ms) var(--easing, 500ms),-webkit-transform var(--timing, 500ms) var(--easing, 500ms);-o-transition:opacity var(--timing, 500ms) var(--easing, 500ms),-o-transform var(--timing, 500ms) var(--easing, 500ms);-moz-transition:opacity var(--timing, 500ms) var(--easing, 500ms),transform var(--timing, 500ms) var(--easing, 500ms),-moz-transform var(--timing, 500ms) var(--easing, 500ms);transition:opacity var(--timing, 500ms) var(--easing, 500ms),transform var(--timing, 500ms) var(--easing, 500ms);transition:opacity var(--timing, 500ms) var(--easing, 500ms),transform var(--timing, 500ms) var(--easing, 500ms),-webkit-transform var(--timing, 500ms) var(--easing, 500ms),-moz-transform var(--timing, 500ms) var(--easing, 500ms),-o-transform var(--timing, 500ms) var(--easing, 500ms);-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;width:var(--dropdown-menu-width, 12rem);z-index:1000}.hot-dropdown__menu>div{margin:0;max-height:auto;overflow:auto;padding:0}.hot-dropdown__menu.show{opacity:1;pointer-events:all}:host(.hot-dropup) .hot-dropdown__menu{bottom:100%;margin-bottom:var(--spacer-1, 0.25rem);margin-top:0;top:auto}:host(.hot-dropright) .hot-dropdown__menu{left:100%;margin-left:var(--spacer-1, 0.25rem);margin-top:0;right:auto;top:0}:host(.hot-dropleft) .hot-dropdown__menu{left:auto;margin-right:var(--spacer-1, 0.25rem);margin-top:0;right:100%;top:0}:host ::slotted(._hot-scroll){height:auto !important;max-height:288px;overflow:auto}:host ::slotted(._hot-scroll hot-dropdown-menu-item){overflow:hidden;-o-text-overflow:ellipsis;text-overflow:ellipsis}:host(.hot-dropdocked)::before,:host(.hot-dropdocked.hot-dropup)::before,:host(.hot-dropdocked.hot-dropright)::before,:host(.hot-dropdocked.hot-dropleft)::before{background-color:var(--gray-200, #e6e9ed);content:"";height:100%;left:0;opacity:0;pointer-events:none;position:fixed;top:0;-webkit-transition:opacity var(--timing, 500ms) var(--easing, cubic-bezier(0.2, 1, 0.2, 1));-o-transition:opacity var(--timing, 500ms) var(--easing, cubic-bezier(0.2, 1, 0.2, 1));-moz-transition:opacity var(--timing, 500ms) var(--easing, cubic-bezier(0.2, 1, 0.2, 1));transition:opacity var(--timing, 500ms) var(--easing, cubic-bezier(0.2, 1, 0.2, 1));width:100%;z-index:999}@media all and (max-width: 768px){:host(.hot-dropdocked) .hot-dropdown__menu,:host(.hot-dropdocked.hot-dropup) .hot-dropdown__menu,:host(.hot-dropdocked.hot-dropright) .hot-dropdown__menu,:host(.hot-dropdocked.hot-dropleft) .hot-dropdown__menu{-webkit-border-radius:var(--border-radius, 0.25rem) var(--border-radius, 0.25rem) 0 0;-moz-border-radius:var(--border-radius, 0.25rem) var(--border-radius, 0.25rem) 0 0;border-radius:var(--border-radius, 0.25rem) var(--border-radius, 0.25rem) 0 0;bottom:0 !important;left:0;margin:0;opacity:1;position:fixed;right:0;top:auto !important;-webkit-transform:translateY(100%);-moz-transform:translateY(100%);-ms-transform:translateY(100%);-o-transform:translateY(100%);transform:translateY(100%);width:100%}}:host(.hot-dropdocked) .hot-dropdown__menu.show,:host(.hot-dropdocked.hot-dropup) .hot-dropdown__menu.show,:host(.hot-dropdocked.hot-dropright) .hot-dropdown__menu.show,:host(.hot-dropdocked.hot-dropleft) .hot-dropdown__menu.show{-webkit-transform:translateY(0);-moz-transform:translateY(0);-ms-transform:translateY(0);-o-transform:translateY(0);transform:translateY(0)}@media all and (max-width: 768px){:host(.hot-dropdocked[active])::before,:host(.hot-dropdocked[active].hot-dropup)::before,:host(.hot-dropdocked[active].hot-dropright)::before,:host(.hot-dropdocked[active].hot-dropleft)::before{opacity:.9;pointer-events:all}}', ""]);
          const s = a;
        },
        5556: (t, e, o) => {
          o.d(e, {
            Z: () => s
          });
          var n = o(6738),
            r = o.n(n),
            i = o(7705),
            a = o.n(i)()(r());
          a.push([t.id, ":host{border-top:var(--component-border-width, 0.0625rem) solid var(--component-border-color, #e6e9ed);display:block;height:0;margin:var(--spacer-2, 0.5rem) 0;overflow:hidden}", ""]);
          const s = a;
        },
        4954: (t, e, o) => {
          o.d(e, {
            Z: () => s
          });
          var n = o(6738),
            r = o.n(n),
            i = o(7705),
            a = o.n(i)()(r());
          a.push([t.id, ":host{color:var(--gray-500, #707780);display:block;font-size:var(--text-1, 0.75rem);margin:0;padding:var(--spacer-2, 0.5rem) var(--spacer-4, 1rem);white-space:nowrap}", ""]);
          const s = a;
        },
        3971: (t, e, o) => {
          o.d(e, {
            Z: () => s
          });
          var n = o(6738),
            r = o.n(n),
            i = o(7705),
            a = o.n(i)()(r());
          a.push([t.id, ":host{background-color:transparent;border:0;color:var(--gray-700, #32363b);cursor:pointer;display:block;font-weight:var(--font-weight, 400);outline:0;padding:var(--spacer-2, 0.5rem) var(--spacer-4, 1rem);-webkit-transition:background-color var(--timing, 500ms) var(--easing, cubic-bezier(0.2, 1, 0.2, 1)),color var(--timing, 500ms) var(--easing, cubic-bezier(0.2, 1, 0.2, 1));-o-transition:background-color var(--timing, 500ms) var(--easing, cubic-bezier(0.2, 1, 0.2, 1)),color var(--timing, 500ms) var(--easing, cubic-bezier(0.2, 1, 0.2, 1));-moz-transition:background-color var(--timing, 500ms) var(--easing, cubic-bezier(0.2, 1, 0.2, 1)),color var(--timing, 500ms) var(--easing, cubic-bezier(0.2, 1, 0.2, 1));transition:background-color var(--timing, 500ms) var(--easing, cubic-bezier(0.2, 1, 0.2, 1)),color var(--timing, 500ms) var(--easing, cubic-bezier(0.2, 1, 0.2, 1))}:host(:hover){background-color:var(--gray-200, #e6e9ed);outline:0;text-decoration:none}:host(:focus),:host(:active){background-color:var(--gray-300, #c9ced4);outline:0;text-decoration:none}:host(.hot-dropdown-menu__item--active),:host([active]){background-color:var(--gray-200, #e6e9ed);text-decoration:none}:host(.hot-dropdown-menu__item--disabled),:host([disabled]){background-color:transparent;color:var(--gray-400, #9ea4ac);cursor:not-allowed;opacity:.4}", ""]);
          const s = a;
        },
        5097: (t, e, o) => {
          o.d(e, {
            Z: () => s
          });
          var n = o(6738),
            r = o.n(n),
            i = o(7705),
            a = o.n(i)()(r());
          a.push([t.id, ':host{font-family:var(--font-family, "Nunito Sans", -apple-system, blinkmacsystemfont, "Segoe UI", helvetica, arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol")}:host *,:host *::before,:host *::after{-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box}', ""]);
          const s = a;
        }
      },
      e = {};
    function o(n) {
      var r = e[n];
      if (void 0 !== r) return r.exports;
      var i = e[n] = {
        id: n,
        exports: {}
      };
      return t[n](i, i.exports, o), i.exports;
    }
    o.n = t => {
      var e = t && t.__esModule ? () => t.default : () => t;
      return o.d(e, {
        a: e
      }), e;
    }, o.d = (t, e) => {
      for (var n in e) o.o(e, n) && !o.o(t, n) && Object.defineProperty(t, n, {
        enumerable: !0,
        get: e[n]
      });
    }, o.o = (t, e) => Object.prototype.hasOwnProperty.call(t, e), o.r = t => {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(t, "__esModule", {
        value: !0
      });
    };
    var n = {};
    return (() => {
      o.r(n);
      const t = require("@babel/runtime/helpers/slicedToArray");
      var e = o.n(t);
      const r = require("@babel/runtime/helpers/toConsumableArray");
      var i = o.n(r);
      const a = require("@babel/runtime/helpers/classCallCheck");
      var s = o.n(a);
      const c = require("@babel/runtime/helpers/createClass");
      var d = o.n(c);
      const l = require("@babel/runtime/helpers/assertThisInitialized");
      var u = o.n(l);
      const h = require("@babel/runtime/helpers/get");
      var m = o.n(h);
      const p = require("@babel/runtime/helpers/inherits");
      var v = o.n(p);
      const f = require("@babel/runtime/helpers/possibleConstructorReturn");
      var g = o.n(f);
      const b = require("@babel/runtime/helpers/getPrototypeOf");
      var y = o.n(b);
      const w = require("@babel/runtime/helpers/wrapNativeSuper");
      var _ = o.n(w),
        k = o(5097);
      const E = function (t) {
        v()(r, t);
        var e,
          o,
          n = (e = r, o = function () {
            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
            if (Reflect.construct.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
              return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
            } catch (t) {
              return !1;
            }
          }(), function () {
            var t,
              n = y()(e);
            if (o) {
              var r = y()(this).constructor;
              t = Reflect.construct(n, arguments, r);
            } else t = n.apply(this, arguments);
            return g()(this, t);
          });
        function r(t) {
          var e;
          s()(this, r);
          var o = (e = n.call(this)).getTemplate(),
            i = document.createElement("template");
          i.innerHTML = o;
          var a = i.content.querySelector("style");
          return a && (a.innerHTML = "".concat(a.innerHTML, " ").concat(k.Z.toString())), window.ShadyCSS && window.ShadyCSS.prepareTemplate(i, t), e.attachShadow({
            mode: "open"
          }), e.shadowRoot.appendChild(document.importNode(i.content, !0)), e;
        }
        return d()(r, [{
          key: "connectedCallback",
          value: function () {
            window.ShadyCSS && window.ShadyCSS.styleElement(this);
          }
        }, {
          key: "getTemplate",
          value: function () {
            return "";
          }
        }]), r;
      }(_()(HTMLElement));
      function x(t, e) {
        customElements.get(t) || customElements.define(t, e);
      }
      var S = "hot-dropdown",
        C = "active",
        R = {
          ENTER_KEY_CODE: 13,
          DOWN_ARROW_KEY_CODE: 40,
          UP_ARROW_KEY_CODE: 38,
          ESCAPE_KEY_CODE: 27
        },
        M = o(1464),
        z = o(5556);
      var L = "hot-dropdown-menu-divider";
      x(L, function (t) {
        v()(r, t);
        var e,
          o,
          n = (e = r, o = function () {
            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
            if (Reflect.construct.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
              return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
            } catch (t) {
              return !1;
            }
          }(), function () {
            var t,
              n = y()(e);
            if (o) {
              var r = y()(this).constructor;
              t = Reflect.construct(n, arguments, r);
            } else t = n.apply(this, arguments);
            return g()(this, t);
          });
        function r() {
          var t;
          return s()(this, r), (t = n.call(this, L))._onMouseDown = function (t) {
            return t.stopPropagation();
          }, t;
        }
        return d()(r, [{
          key: "connectedCallback",
          value: function () {
            m()(y()(r.prototype), "connectedCallback", this).call(this), this.addEventListener("mousedown", this._onMouseDown);
          }
        }, {
          key: "disconnectedCallback",
          value: function () {
            this.removeEventListener("mousedown", this._onMouseDown);
          }
        }, {
          key: "getTemplate",
          value: function () {
            return "<style>".concat(z.Z.toString(), "</style>");
          }
        }]), r;
      }(E));
      var A = o(4954);
      var O = "hot-dropdown-menu-header";
      x(O, function (t) {
        v()(r, t);
        var e,
          o,
          n = (e = r, o = function () {
            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
            if (Reflect.construct.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
              return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
            } catch (t) {
              return !1;
            }
          }(), function () {
            var t,
              n = y()(e);
            if (o) {
              var r = y()(this).constructor;
              t = Reflect.construct(n, arguments, r);
            } else t = n.apply(this, arguments);
            return g()(this, t);
          });
        function r() {
          var t;
          return s()(this, r), (t = n.call(this, O))._onMouseDown = function (t) {
            return t.stopPropagation();
          }, t;
        }
        return d()(r, [{
          key: "connectedCallback",
          value: function () {
            m()(y()(r.prototype), "connectedCallback", this).call(this), this.addEventListener("mousedown", this._onMouseDown);
          }
        }, {
          key: "disconnectedCallback",
          value: function () {
            this.removeEventListener("mousedown", this._onMouseDown);
          }
        }, {
          key: "getTemplate",
          value: function () {
            return "\n      <style>".concat(A.Z.toString(), "</style>\n      <slot></slot>\n    ");
          }
        }]), r;
      }(E));
      var D = o(3971);
      var P = "hot-dropdown-menu-item";
      x(P, function (t) {
        v()(r, t);
        var e,
          o,
          n = (e = r, o = function () {
            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
            if (Reflect.construct.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
              return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
            } catch (t) {
              return !1;
            }
          }(), function () {
            var t,
              n = y()(e);
            if (o) {
              var r = y()(this).constructor;
              t = Reflect.construct(n, arguments, r);
            } else t = n.apply(this, arguments);
            return g()(this, t);
          });
        function r() {
          return s()(this, r), n.call(this, P);
        }
        return d()(r, [{
          key: "connectedCallback",
          value: function () {
            m()(y()(r.prototype), "connectedCallback", this).call(this), this._addAccessibility();
          }
        }, {
          key: "_addAccessibility",
          value: function () {
            this.hasAttribute("tabindex") || this.setAttribute("tabindex", "0");
          }
        }, {
          key: "getTemplate",
          value: function () {
            return "\n      <style>".concat(D.Z.toString(), "</style>\n      <slot></slot>\n    ");
          }
        }]), r;
      }(E)), x(S, function (t) {
        v()(a, t);
        var o,
          n,
          r = (o = a, n = function () {
            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
            if (Reflect.construct.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
              return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
            } catch (t) {
              return !1;
            }
          }(), function () {
            var t,
              e = y()(o);
            if (n) {
              var r = y()(this).constructor;
              t = Reflect.construct(e, arguments, r);
            } else t = e.apply(this, arguments);
            return g()(this, t);
          });
        function a() {
          var t;
          return s()(this, a), (t = r.call(this, S))._slotButton = t.shadowRoot.querySelector("slot[name=button]"), t.openMenu = t.openMenu.bind(u()(t)), t.closeMenu = t.closeMenu.bind(u()(t)), t._updatePlacement = t._updatePlacement.bind(u()(t)), t._onChangeSlotButton = t._onChangeSlotButton.bind(u()(t)), t._onChangeScroll = t._onChangeScroll.bind(u()(t)), t._onShowMenu = t._onShowMenu.bind(u()(t)), t._onHideMenu = t._onHideMenu.bind(u()(t)), t._toggleMenu = t._toggleMenu.bind(u()(t)), t._onKeyDown = t._onKeyDown.bind(u()(t)), t;
        }
        return d()(a, [{
          key: "connectedCallback",
          value: function () {
            m()(y()(a.prototype), "connectedCallback", this).call(this), this._onChangeSlotButton(), this._slotButton.addEventListener("slotchange", this._onChangeSlotButton);
          }
        }, {
          key: "disconnectedCallback",
          value: function () {
            this.removeAttribute(C), this._slotButton.removeEventListener("slotchange", this._onChangeSlotButton), window.removeEventListener("scroll", this._updatePlacement), window.removeEventListener("keydown", this._onKeyDown);
          }
        }, {
          key: "_onChangeScroll",
          value: function () {
            var t = this._scroll,
              e = t.scrollHeight,
              o = t.scrollTop,
              n = t.offsetHeight;
            e - o - (this.querySelector("hot-dropdown-menu-item").offsetHeight || 30) < n && this.dispatchEvent(new Event("scrollend"));
          }
        }, {
          key: "_onKeyDown",
          value: function (t) {
            var e = i()(Object.keys(R)).map(function (t) {
                return R[t];
              }),
              o = t.keyCode;
            e.indexOf(o) >= 0 && t.preventDefault();
            var n = i()(this.querySelectorAll("[tabindex]:not([disabled]):not(.disabled)"));
            !function (t, e, o, n) {
              if (o.length) {
                var r = n === e.UP_ARROW_KEY_CODE,
                  i = n === e.DOWN_ARROW_KEY_CODE,
                  a = o.findIndex(function (t) {
                    return t === document.activeElement;
                  });
                if (n === e.ENTER_KEY_CODE && a >= 0) o[a].click(), t.closeMenu();else if (n === e.ESCAPE_KEY_CODE) t.closeMenu();else if (r || i) {
                  if (i && a + 1 === o.length) return;
                  i ? a++ : a--, o[a < 0 ? 0 : a].focus();
                }
              }
            }(this, R, n, o);
          }
        }, {
          key: "_onChangeSlotButton",
          value: function () {
            var t = this.getAttribute("target"),
              e = this._slotButton.assignedNodes()[0];
            return t && (e = this.querySelector("#".concat(t))), e instanceof HTMLInputElement ? (e.addEventListener("focus", this._toggleMenu), void e.addEventListener("blur", this.closeMenu)) : e ? e.addEventListener("click", this._toggleMenu) : void console.warn("no target found");
          }
        }, {
          key: "_toggleMenu",
          value: function () {
            this.hasAttribute(C) ? this.closeMenu() : this.openMenu();
          }
        }, {
          key: "openMenu",
          value: function () {
            var t = this;
            this.setAttribute(C, ""), setTimeout(function () {
              window.addEventListener("click", t.closeMenu), window.addEventListener("scroll", t._updatePlacement), window.addEventListener("keydown", t._onKeyDown);
            });
            var e = this.shadowRoot.querySelector(".hot-dropdown__menu");
            e.style.display = "block", this._updatePlacement(), this._toggleAnimationEvent(e, "addEventListener", this._onShowMenu), e.classList.add("show"), this.dispatchEvent(new CustomEvent("open"));
          }
        }, {
          key: "_onShowMenu",
          value: function () {
            var t = this.shadowRoot.querySelector(".hot-dropdown__menu");
            this._toggleAnimationEvent(t, "removeEventListener", this._onShowMenu), this.dispatchEvent(new CustomEvent("show"));
          }
        }, {
          key: "closeMenu",
          value: function () {
            this.removeAttribute(C), this.dispatchEvent(new CustomEvent("close")), window.removeEventListener("click", this.closeMenu), window.removeEventListener("scroll", this._updatePlacement), window.removeEventListener("keydown", this._onKeyDown);
            var t = this.shadowRoot.querySelector(".hot-dropdown__menu");
            this._toggleAnimationEvent(t, "addEventListener", this._onHideMenu), t.classList.remove("show");
          }
        }, {
          key: "_onHideMenu",
          value: function () {
            var t = this.hasAttribute(C),
              e = this.shadowRoot.querySelector(".hot-dropdown__menu");
            this._toggleAnimationEvent(e, "removeEventListener", this._onHideMenu), t || (e.style.display = "none", this.dispatchEvent(new CustomEvent("hide")));
          }
        }, {
          key: "_updatePlacement",
          value: function () {
            var t = this.classList.contains("hot-dropup"),
              o = this.classList.contains("hot-dropright"),
              n = this.classList.contains("hot-dropleft");
            if (!(o && n && t)) {
              var r = this.shadowRoot.querySelector(".hot-dropdown__menu"),
                i = this.getBoundingClientRect(),
                a = e()(this.shadowRoot.children, 1)[0],
                s = this.getAttribute("menu-side") || "left",
                c = a.offsetHeight + r.offsetHeight,
                d = i.top >= c,
                l = window.innerHeight - (c + i.top) > 0,
                u = t || !l && (l || d) ? "top" : "bottom";
              if ("left" === s ? i.left + r.offsetWidth > window.innerWidth ? (r.style.right = 0, r.style.left = "") : (r.style.left = 0, r.style.right = "") : i.right - r.offsetWidth < 0 ? (r.style.left = 0, r.style.right = "") : (r.style.right = 0, r.style.left = ""), "bottom" === u) return r.style.bottom = "auto", void (r.style.top = "100%");
              r.style.bottom = "100%", r.style.top = "auto";
            }
          }
        }, {
          key: "_toggleAnimationEvent",
          value: function (t, e, o) {
            t[e]("webkitTransitionEnd", o), t[e]("oTransitionEnd", o), t[e]("msAnimationEnd", o), t[e]("transitionend", o);
          }
        }, {
          key: "getTemplate",
          value: function () {
            return "\n      <div>\n        <style>".concat(M.Z.toString(), '</style>\n        <slot name="button"></slot>\n        <div class="hot-dropdown__menu">\n          <slot name="menu"></slot>\n        </div>\n      </div>\n    ');
          }
        }]), a;
      }(E));
    })(), n;
  })();
});